// Instance
import MainAPI from "@/app/apis/main/main-api.js";

// Endpoints
import { API, ENDPOINTS } from "@/app/apis/main/_connection/connection-api.js";

// Query String
const queryString = require("querystring");

class breederAPI extends MainAPI {
    async updateBreederDetails(details) {
        const newFormData = new FormData();

        newFormData.append("formData", JSON.stringify(details.requestDetails));
        newFormData.append("profileImage", details.breederImg);

        return API.put(`${ENDPOINTS.PUT_BREEDER}/details/update`, newFormData);
    }

    async approvedDeclinedBreeder(details) {
        return API.put(`${ENDPOINTS.PUT_BREEDER}/details/approved-declined`, details);
    }

    async getBreedersList(queryParams) {
        return API.get(`/admin${ENDPOINTS.GET_BREEDER}?${queryString.stringify(queryParams)}`);
    }

    async getBreedersSuggestionList(queryParams) {
        return API.get(`${ENDPOINTS.GET_BREEDER}/suggest?${queryString.stringify(queryParams)}`);
    }

    async getBreederDetailsById(breederId) {
        return API.get(`/admin${ENDPOINTS.GET_BREEDER}/${breederId}`);
    }

    async getUnverifiedBreeder() {
        return API.get(`${ENDPOINTS.GET_BREEDER}/count/unverified`);
    }

    async reactivateDeactivateBreeder(details) {
        return API.put(`${ENDPOINTS.PUT_BREEDER}/activate-deactivate`, details);
    }

    /**
     * @return Object
     */
    async addBreeder(breederDetails) {
        const newFormData = new FormData();

        newFormData.append("formData", JSON.stringify(breederDetails.requestDetails));

        newFormData.append("profileImage", breederDetails.breederImg);

        return API.post(`${ENDPOINTS.POST_BREEDERS}/register`, newFormData, {
            header: {
                "Content-Type": "multipart/form-data",
            },
        });
    }

    async deleteBreeder(breederId) {
        return API.delete(`${ENDPOINTS.DELETE_BREEDER}/${breederId}`);
    }

    async getBreederById(userId) {
        return API.get(`${ENDPOINTS.GET_BREEDER}?f_userId=${userId}`);
    }
    
    async addBreederBio(details) {
        return API.post(`${ENDPOINTS.PUT_BREEDER}/create-bio`, details);
    }

    async updateBreederBio(details) {
        return API.put(`${ENDPOINTS.PUT_BREEDER}/update-bio`, details);
    }
}

export default new breederAPI();
